import { render, staticRenderFns } from "./RegisterCustomer.vue?vue&type=template&id=00f7e7e1&"
import script from "./RegisterCustomer.vue?vue&type=script&lang=js&"
export * from "./RegisterCustomer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCustomer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterCustomer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports